// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"57c63040","787":"9565293f","796":"cbfbe453"}[chunkId] + ".chunk.js";
};